<div class="demo-container">
    <h1 class="page-title">Loader Preview</h1>
    <p class="subtitle">All loader variants using the app theme</p>

    <!-- ── Size Variants ─────────────────────────────────────── -->
    <section class="demo-section">
        <h2 class="section-title">Sizes</h2>

        <div class="demo-row">
            <div class="demo-card card">
                <span class="demo-label">sm (24 px)</span>
                <app-loader size="sm"></app-loader>
            </div>

            <div class="demo-card card">
                <span class="demo-label">md (48 px)</span>
                <app-loader size="md"></app-loader>
            </div>

            <div class="demo-card card">
                <span class="demo-label">lg (72 px)</span>
                <app-loader size="lg"></app-loader>
            </div>
        </div>
    </section>

    <!-- ── With Message ──────────────────────────────────────── -->
    <section class="demo-section">
        <h2 class="section-title">With Message</h2>

        <div class="demo-row">
            <div class="demo-card card">
                <app-loader size="sm" message="Salvando..."></app-loader>
            </div>

            <div class="demo-card card">
                <app-loader message="Carregando ordens de serviço..."></app-loader>
            </div>

            <div class="demo-card card">
                <app-loader size="lg" message="Aguarde um momento..."></app-loader>
            </div>
        </div>
    </section>

    <!-- ── Inline Usage ──────────────────────────────────────── -->
    <section class="demo-section">
        <h2 class="section-title">Inline (inside a button)</h2>

        <div class="demo-row">
            <button class="btn-primary inline-demo-btn" disabled>
                <app-loader size="sm"></app-loader>
                <span>Processando...</span>
            </button>
        </div>
    </section>

    <!-- ── Overlay ───────────────────────────────────────────── -->
    <section class="demo-section">
        <h2 class="section-title">Full-Page Overlay</h2>

        <div class="demo-row">
            <button class="btn-primary overlay-btn" (click)="toggleOverlay()">
                <span class="btn-title">Mostrar Overlay (3 s)</span>
            </button>
        </div>
    </section>

    <app-loader *ngIf="showOverlay" [overlay]="true" size="lg" message="Carregando sistema..."></app-loader>
</div>